import { useContext } from "react";
import { JourneyContext } from "../components/JourneyProvider";
const useJourneyContext = () => {
  const ctx = useContext(JourneyContext);
  if (ctx === null) {
    throw new Error("Wrap your component inside a JourneyProvider");
  }
  return ctx;
};
var useJourneyContext_default = useJourneyContext;
export {
  useJourneyContext_default as default
};
